import { withPrefix } from 'gatsby';

const useBasePath = () =>
  withPrefix('')
    // strip trailing slashes
    .replace(/\/+$/, '');

export default useBasePath;
